/**
 * Extract Core `{ errors }` from an Axios rejection, or null.
 * Null-safe: does not throw when `error.response` is missing (network failures).
 */
export function errorsFromAxios(error) {
  if (error && error.response && error.response.data && error.response.data.errors) {
    return error.response.data.errors;
  }
  return null;
}

/** Dispatch to Vuex `pushErrors` when Core returned field errors. */
export function pushAxiosErrors(store, error) {
  const errors = errorsFromAxios(error);
  if (errors) store.dispatch('pushErrors', errors);
}
